import i18n from "i18next";
import { ObjectAttributeValueWithField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithField.ts";
import { LabelValueViewItem } from "src/components/common/misc/LabelValueView.tsx";
import {
	attributeValueToUserFriendlyString,
	decodeObjectAttributeValue,
} from "src/components/views/erp/objectAttributes/objectAttributeValueConverting.ts";

/** Builds a read-only section of the filled attribute values, or nothing when no attribute has a value. */
export function getObjectAttributeLabelValueSection(attributes: ObjectAttributeValueWithField[]): LabelValueViewItem {
	const fields = attributes.flatMap(({ field, attributeValue }) => {
		if (attributeValue == null) return [];

		const value = attributeValueToUserFriendlyString(
			decodeObjectAttributeValue(attributeValue, field.type),
			field.type,
		);
		if (value === "") return [];

		return [
			{
				label: field.label,
				value,
				multiline: field.type.type === "textarea" || field.type.type === "richText",
			},
		];
	});

	return (
		fields.length > 0 && {
			type: "section",
			label: i18n.t("attributes"),
			fields,
		}
	);
}
